import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { RelatedProperty } from '../../../../types';
import { setStatus } from '../../../slices/contactForm';
import {
  cancelMultipleLeads,
  openMultipleLeadsSuccessModal
} from '../../../slices/multipleLeads';
import { RootState } from '../../../store';
import fetchRelatedProperties, {
  FetchRelatedPropertiesRequest
} from '../fetchers/fetchRelatedProperties';

export function* watchCancelMultipleLeadsWorker() {
  const values: FetchRelatedPropertiesRequest = yield select(
    (state: RootState) => ({
      email: state.user.email,
      propertyId: state.multipleLeads.propertyId,
      type: state.multipleLeads.type
    })
  );

  const properties: Array<RelatedProperty> = yield call(
    fetchRelatedProperties,
    values
  );

  if (properties.length > 0) {
    yield all([
      put(openMultipleLeadsSuccessModal(properties)),
      put(setStatus('initial'))
    ]);
  } else {
    yield put(setStatus('success'));
  }
}

export default function* watchCancelMultipleLeads() {
  yield takeLatest(cancelMultipleLeads, watchCancelMultipleLeadsWorker);
}
